export const cloneObject = <T>(obj: T): T => {
  return JSON.parse(JSON.stringify(obj));
};
